<div class="page">
    <div class="header">
        <div class="list-type">
                <div *ngFor="let item of listType" [class]="item.type == type ? 'type-item active' : 'type-item'" (click)='changeType(item)'>
                    <div class="name">
                        {{item.name}}
                    </div>
                    <div class="num">
                        {{item.num}}
                    </div>
                </div>
        </div>
    </div>
    <div class="content">
        <SiteDiary-List-MyAction  (listItemButton)="updateList($event)" [list]='list' *ngIf="isShowType == 2"></SiteDiary-List-MyAction>
        <table class="generic-table" *ngIf="isShowType == 1">
            <thead class="-sticky">
              <tr >
                <th>ID</th>
                <th>Subject</th>
                <th>Status</th>
                <th>
                    Author
                </th>
                <th>
                    Handler
                </th>

                <th>
                    (1) Location of Work
                </th>
                <th>
                    (2) Work to be inspected/surveyed
                </th>
                <th>
                    Work to be inspected/surveyed DateTime
                </th>
                <th>
                    Late Submission(lessthan 24 hours)
                </th>
                <th>
                </th>
              </tr>
            </thead>
            <tbody class="results-tbody work-package--results-tbody">
              <tr tabindex="0" *ngFor="let item of list" (contextmenu)="onRightClick($event,item)">
                <td><span class="line" (click)='toDeatail(item)'>{{item.id}}</span></td>
                <td>{{item.subject}}</td>
                <td>{{item.status.name}}</td>
                <td>{{item.author.lastname}} {{item.author.firstname}} {{item.author.position}}</td>
                <td style="color: #4d6daa;" class="multi-line-cell">
                  <div class="multi-line-content" style="text-align: center;">
                    {{item.handler}}
                  </div>
                </td>
                <td class="multi-line-cell"><div class="multi-line-content">{{item.location_of_work}}</div></td>
                <td class="multi-line-cell"><div class="multi-line-content">{{item.inspected_surveyed}}</div></td>
                <td>{{item.surveyed_date_time}}</td>
                <td>
                    <span style="color: red;" *ngIf="item.late_submission!='no'">Yes</span>
                    <span *ngIf="item.late_submission=='no'">No</span>
                </td>
                <td class="activity" >
                    <span class="line" (click)='showActivity(item)'>
                        ACTIVITY
                    </span>
                </td>
              </tr>
            </tbody>
        </table>
        <table class="generic-table" *ngIf="isShowType == 3">
            <thead class="-sticky">
              <tr >
                <th>ID</th>
                <th>File ID</th>
                <th>{{ i18n.t("js.check-lists.list-title.status") }}</th>
                <th>
                    {{ i18n.t("js.check-lists.list-title.theme") }}
                </th>
                <th>
                   {{ i18n.t("js.check-lists.list-title.Type") }}
                </th>
           
                <th>
                    {{ i18n.t("js.check-lists.list-title.creator") }}
                </th>
                <th>
                    {{ i18n.t("js.check-lists.list-title.createAt") }}
                </th>
                <th>
                   {{ i18n.t("js.check-lists.list-title.handler") }}
                </th>
              </tr>
            </thead>
            <tbody class="results-tbody work-package--results-tbody">
              <tr tabindex="0" *ngFor="let item of list" (click)='toCheckListDeatail(item,$event)'>
                <td><span class="line" >{{item.id}}</span></td>
                <td>{{item.file_ref_no}}</td>
                <td>{{item.state}}</td>
                <td>{{item.template}}</td>
                <td>{{item.type}}</td>
                <td>{{item.creator}}</td>
                <td>{{item.created_at}}</td>
                <td>
                 {{item.assigner_last == null?(item.executor ==null?item.assigner: (item.executor?.firstname + ' ' + item.executor?.lastname)): (
            item.executor_last ==null?item.assigner_last: (item.executor_last?.firstname + ' ' + item.executor_last?.lastname))}}
                </td>
            
              </tr>
            </tbody>
        </table>
        <table class="generic-table" *ngIf="isShowType == 4">
            <thead class="-sticky">
              <tr >
                <th>Month</th>
                <th>Status</th>
                <th>
                    Created by
                </th>
                <th>
                  Created at
                </th>
           
                <th>
                    Handler
                </th>
              </tr>
            </thead>
            <tbody class="results-tbody work-package--results-tbody">
              <tr tabindex="0" *ngFor="let item of list"  (click)='toLabourReturnDeatail(item,$event)'>
                <td>{{item.month}}</td>
                <td>{{item.state}}</td>
                <td>{{item.created_by.firstname+' '+item.created_by.lastname}}</td>
                <td>{{item.created_at}}</td>
                <td>{{showHandler(item)}}</td>
              </tr>
            </tbody>
        </table>
          <div id="page"></div>
    </div>
    <div class="dropdown-relative dropdown -overflow-in-view" id="myActionMenu" style="position: fixed;" [ngStyle]="{'top': itemY,'left': itemX }" [style.left.px]="itemX" [style.top.px]="itemY" >
      <ul class="dropdown-menu" role="menu">
        <li><a class="menu-item copyViewMenuItem" href="#" (click)="resubmit()">
            <i aria-hidden="true" class="icon-action-menu icon-copy" title=""></i>
            <span>{{i18n.t("js.file-ref-no.resubmit")}}</span>
          </a></li>
      </ul>
    </div>
    <div class="mask" *ngIf="isShowActive">
        <div class="mask-content">
            <div class="head">
                <div class="name">
                    <!-- 123344 -->
                     {{ActiveName}}
                </div>
                <div class="close" (click)='close()'>X</div>
            </div>
            <div class="content">
                <div class="titleTime">{{titleTime}}</div>
                <div class="embeddedLog">
                    <div *ngFor="let item of embeddedObj.elements" class="embeddeItem" >
                        <div *ngIf="item.userData&&item.userData.name" class="embeddeUserInfo">
                            <user-avatar
                                [attr.data-user-name]="item.userData.name"
                                [attr.data-user-id]="item.userData.id"
                                data-class-list="avatar">
                            </user-avatar>
                            <div class="string">{{item.userData.str}}</div>
                        </div>
                        <div  *ngFor="let items of item.details" class="infoItem">
                            <div [innerHtml]="items.html"></div>
                        </div>
                    </div>
                </div>
                <div class="riscActivtiesLog">
                    <div class="handlerlog">Handler Log</div>
                    <div class="activtiesLog">
                        <div *ngFor="let itemA of embeddedObj.riscActivtiesLog">
                            <div *ngIf="itemA.userData&&itemA.userData.name" class="embeddeUserInfo">
                                <user-avatar
                                    [attr.data-user-name]="itemA.userData.name"
                                    [attr.data-user-id]="itemA.userData.id"
                                    data-class-list="avatar">
                                </user-avatar>
                                <div class="string">{{itemA.userData.str}}</div>
                            </div>
                            <div class="infoItem" [innerHtml]="itemA.details.html"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>